import React from "react";
import { Box, Typography } from "@mui/material";
import AnimatedQuickIcon from "./AnimatedQuickIcon";
import { LUXURY } from "data/guestLuxuryTheme";

const QuickAction = ({ title, actionLabel, illustration, onClick }) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    sx={{
      appearance: "none",
      WebkitTapHighlightColor: "transparent",
      border: 0,
      width: "100%",
      minWidth: 0,
      height: 118,
      minHeight: 112,
      px: 0.65,
      py: 1,
      borderRadius: "18px",
      bgcolor: LUXURY.cardLight,
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.55,
      boxShadow: "0 8px 18px rgba(0,0,0,0.18)",
      "&:active": { transform: "scale(0.97)" },
      "@media (prefers-reduced-motion: reduce)": {
        "&:active": { transform: "none" },
      },
    }}
  >
    <AnimatedQuickIcon name={illustration} size={26} color={LUXURY.goldDeep} />
    <Box sx={{ minWidth: 0, width: "100%" }}>
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: "0.64rem",
          color: LUXURY.forestDeep,
          lineHeight: 1.2,
          textAlign: "center",
          minHeight: "2.4em",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          hyphens: "auto",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          mt: 0.1,
          fontSize: "0.6rem",
          color: "rgba(28,25,23,0.5)",
          lineHeight: 1.2,
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {actionLabel}
      </Typography>
    </Box>
  </Box>
);

export default QuickAction;
